import React from 'react';
import Header from "../thema/tema1/component/Header";
import Footer from "../thema/tema1/component/Footer";
import SideMenu from "../thema/tema1/component/SideMenu";
import PageContext from "../thema/tema1/component/PageContext";
import Properties from "../const/Properties";
import CustomTable from "../thema/tema1/component/CustomTable"
import CustomModal from "../thema/tema1/component/CustomModal"
import axios from 'axios';
import jsPDF from "jspdf";
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import Moment from 'moment';


const tur = 1;

const active = { Zrapor: "active" };
const durumlar = {
    1: "Araç Limana Giriş Yaptı",
    2: "Ek Bilgi Girişi Yapıldı",
    3: "Ücret Belirlendi",
    4: "Ücret Alındı",
    5: "Gemiye Yüklendi",
    6: "Muhasebe İşlmei Tamamlandı",
};
const gidecegiUlkeEnum = {
    0: "BELİRLENMEDİ",
    1: "TRİESTE",
    2: "BARİ",
};
class Zrapor extends React.Component {
    componentDidMount() {
        const scriptPicer = document.createElement("script");
        scriptPicer.src = "/thema/tema1/plugins/custom/datepickerrun.js";
        scriptPicer.type = 'text/javascript';
        scriptPicer.async = true;
        document.body.appendChild(scriptPicer);
    }
    constructor(props) {
        super(props);
        if (localStorage.getItem("token") == "") {
            window.location = '/';
            return false;
        }
        this.state = {
            plaka: "",
            baslangic: "",
            bitis: "",
            firmaId: 0,
            dorsePlaka: "",
            cekiciPlaka: "",
            tarih: "",
            tarihOr: "",
            firmalar: [],
            tasimalar: [],
            content: [],
            pageCount: 0,
            totalRow: 0,
            startRow: 0,
            endRow: 0,
            silId: 0,
            duzenleId: 0,
            makbuzId: 0,
            makbuzDurum: 0,
            silModal: 'none',
            title: ["STATU - TT NUMARASI","TARİH","ÇEKİCİ PLAKA","DORSE PLAKA","GİDECEĞİ ÜLKE", "İŞLEMLER"],
            showDuzenle: false,
            duzenle: false,
            error: 0
        };
        this.firmalarDoldur();
    }
    firmalarDoldur = () => {
        axios({
            method: 'get',
            url: Properties.baseUrl + '/firma/getAll',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                let firmalar = res.data.map((item) =>
                    <option value={item.id}>{item.firmaAdi}</option>);
                this.setState({ firmalar: firmalar });
            })
    }
    onChange = e => {
        Moment.locale('tr');
        this.setState({ ["tarih"]: Moment(e).format('DD/MM/yyyy') })
        this.setState({ ["tarihOr"]: e})
    }


    makbuzYazdir = (e) => {
        const popupWin = window.open('', '_blank');
        popupWin.document.open();
        let ithalat = new Array(); ;
        let ihracat = new Array(); ;
        let gidecegiUlke = 0;
        let gidecegiUlkeStr = "";
        let ttnumarasi = "";
        let surucuadi = "";
        let karnenumarasi = "";
        let pasaportnumarasi = "";
        let geldigigumruk = "";
        let gemiadi = "";
        let muhurnumarasi = "";
        let kapadeti = 0;
        let kg = 0;
        let yukcins  = "";
        let plaka  = "";
        let firma  = "";
        let tarih  = "";
        let geldigigumrukStr  = "";
        let guncelborc  = "";
        axios({
            method: 'post',
            url: Properties.baseUrl + '/tasima/zrapor',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data:
                {
                    tarih:this.state.tarih,
                }
        })
            .then(res => {
                console.log(res.data);
                res.data.forEach(function (value) {
                   if(value.tur == 2 || value.tur == 3){
                       ithalat.push(value);
                    }
                   else{
                       ihracat.push(value);
                   }
                });
                let ihracatstr = "";
                let count = 1;
                let ihracatToplam= 0;
                ihracat.forEach(function (value) {
                    if (value.geldigigumruk == 1) {
                        geldigigumrukStr = "ESENDERE";
                    } else if (value.geldigigumruk == 2) {
                        geldigigumrukStr = "DİLUCU";
                    } else if (value.geldigigumruk == 3) {
                        geldigigumrukStr = "GÜRBULAK";
                    }
                    ihracatstr = ihracatstr + '     <div class="col-6">\n           <div class="row">\n           <div class="col-1 border ">'+count+'</div>\n           <div class="col-1 border  ">'+geldigigumrukStr+'</div>\n           <div class="col-2 border  ">'+value.firmaAdi+'</div>\n           <div class="col-2 border  ">'+value.cekiciPlaka+'</div>\n           <div class="col-1 border  ">'+(value.baf+value.ets+value.liman+value.xray+value.soforUcreti+value.gemiUcreti+value.ens)+'</div>\n  <div class="col-1 border  ">'+value.hizmetBedeli+'</div>\n          <div class="col-2 border  ">'+value.yolGecisUcreti+'</div>\n           <div class="col-2 border  ">'+value.sigorta+'</div>\n           </div>\n           </div>\n           <div class="col-6">\n           <div class="row"> <div class="col-2 border  ">'+value.ekSofor+'</div>\n           <div class="col-2 border  ">'+value.yanici+'</div>\n           <div class="col-2 border  ">'+value.rezervasyon+'</div>\n           <div class="col-1 border  ">'+value.ardiye+'</div>\n <div class="col-1 border  ">'+value.guncelBorc+'</div>           <div class="col-2 border  ">'+(value.baf+value.ets+value.liman+value.xray+value.soforUcreti+value.sigorta+value.ekSofor+value.yanici+value.rezervasyon+value.ardiye+value.yolGecisUcreti+value.gemiUcreti+value.ens+value.hizmetBedeli)+'</div>\n           <div class="col-2 border  ">AÇIKLAMA</div></div>\n           </div>';
                    count = count + 1;
                    ihracatToplam += (value.baf+value.ets+value.liman+value.xray+value.soforUcreti+value.sigorta+value.ekSofor+value.yanici+value.rezervasyon+value.ardiye+value.yolGecisUcreti+value.gemiUcreti+value.ens+value.hizmetBedeli);
                });
                let ithalatstr = "";
                count = 1;
                let ithalatToplam = 0;
                ithalat.forEach(function (value) {
                    if (value.geldigigumruk == 1) {
                        geldigigumrukStr = "ESENDERE";
                    } else if (value.geldigigumruk == 2) {
                        geldigigumrukStr = "DİLUCU";
                    } else if (value.geldigigumruk == 3) {
                        geldigigumrukStr = "GÜRBULAK";
                    }
                    ithalatstr = ithalatstr + '     <div class="col-6">\n           <div class="row">\n           <div class="col-1 border ">'+count+'</div>\n           <div class="col-1 border  ">'+geldigigumrukStr+'</div>\n           <div class="col-2 border  ">'+value.firmaAdi+'</div>\n           <div class="col-2 border  ">'+value.cekiciPlaka+'</div>\n           <div class="col-1 border  ">'+(value.baf+value.ets+value.liman+value.xray+value.soforUcreti+value.gemiUcreti+value.ens)+'</div>\n      <div class="col-1 border  ">'+value.hizmetBedeli+'</div>\n     <div class="col-2 border  ">'+value.yolGecisUcreti+'</div>\n           <div class="col-2 border  ">'+value.sigorta+'</div>\n           </div>\n           </div>\n           <div class="col-6">\n           <div class="row"> <div class="col-2 border  ">'+value.ekSofor+'</div>\n           <div class="col-2 border  ">'+value.yanici+'</div>\n           <div class="col-2 border  ">'+value.rezervasyon+'</div>\n           <div class="col-1 border  ">'+value.ardiye+'</div>\n <div class="col-1 border  ">'+value.guncelBorc+'</div>\n           <div class="col-2 border  ">'+(value.baf+value.ets+value.liman+value.xray+value.soforUcreti+value.sigorta+value.ekSofor+value.yanici+value.rezervasyon+value.ardiye+value.yolGecisUcreti+value.gemiUcreti+value.ens+value.hizmetBedeli)+'</div>\n           <div class="col-2 border  ">AÇIKLAMA</div></div>\n           </div>';
                    count = count + 1;
                    ithalatToplam += (value.baf+value.ets+value.liman+value.xray+value.soforUcreti+value.sigorta+value.ekSofor+value.yanici+value.rezervasyon+value.ardiye+value.yolGecisUcreti+value.gemiUcreti+value.ens+value.hizmetBedeli);

                });
                popupWin.document.write(`
    <html>
<!-- Google Font: Source Sans Pro -->
<style>
body{
font-size: 8px;
}
.border
    {
        border: solid 1px #000;
        padding: 2px;
        text-align: center;
        font-size:5px;
    }
.koyu{
background-color: #aaaaaa;
}
@media print {
body {-webkit-print-color-adjust: exact;}
}

</style>
<head>
    <title>Print</title>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65" crossorigin="anonymous">
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/js/bootstrap.bundle.min.js" integrity="sha384-kenU1KFdBIe4zVF0s0G1M5b4hcpxyD9F7jL+jjXkk+Q2h455rYXK/7HAuoJl+0I4" crossorigin="anonymous"></script>

</head>
<body onload="window.print()" >
<div>
    <div class="content left">
        <div class="row">
           <div class="col-12 border koyu">İHRACAT ` + this.state.tarih + `</div>
           <div class="col-6">
           <div class="row">
           <div class="col-1 border koyu"></div>
           <div class="col-1 border  koyu"></div>
           <div class="col-2 border  koyu">FİRMA</div>
           <div class="col-2 border  koyu">ÇEKİCİ</div>
           <div class="col-1 border  koyu">GEMİ</div>
           <div class="col-1 border  koyu">H.BEDELİ</div>
           <div class="col-2 border  koyu">YOL GEÇİŞ</div>
           <div class="col-2 border  koyu">SİGORTA</div>
           </div>
           </div>
           <div class="col-6">
           <div class="row"> <div class="col-2 border  koyu">Ç.ŞOFÖR</div>
           <div class="col-2 border  koyu">YANICI</div>
           <div class="col-2 border  koyu">REZERVE</div>
           <div class="col-1 border  koyu">ARDİYE</div>
           <div class="col-1 border  koyu">G.BORÇ</div>
           <div class="col-2 border  koyu">TOPLAM</div>
           <div class="col-2 border  koyu">AÇIKLAMA</div></div>
           </div>
           `+ihracatstr+`
</div><br>
  <div class="row">
           <div class="col-12 border koyu">İTHALAT ` + this.state.tarih + `</div>
           <div class="col-6">
           <div class="row">
           <div class="col-1 border koyu"></div>
           <div class="col-1 border  koyu"></div>
           <div class="col-2 border  koyu">FİRMA</div>
           <div class="col-2 border  koyu">ÇEKİCİ</div>
           <div class="col-1 border  koyu">GEMİ</div>
           <div class="col-1 border  koyu">H.BEDELİ</div>
           <div class="col-2 border  koyu">YOL GEÇİŞ</div>
           <div class="col-2 border  koyu">SİGORTA</div>
           </div>
           </div>
           <div class="col-6">
           <div class="row"> <div class="col-2 border  koyu">Ç.ŞOFÖR</div>
           <div class="col-2 border  koyu">YANICI</div>
           <div class="col-2 border  koyu">REZERVE</div>
   <div class="col-1 border  koyu">ARDİYE</div>
           <div class="col-1 border  koyu">G.BORÇ</div>
                      <div class="col-2 border  koyu">TOPLAM</div>
           <div class="col-2 border  koyu">AÇIKLAMA</div></div>
           </div>
           `+ithalatstr+`
            <div class="col-6">
           <div class="row">
           <div class="col-1  "></div>
           <div class="col-1   "></div>
           <div class="col-2   "></div>
           <div class="col-2   "></div>
           <div class="col-2   "></div>
           <div class="col-4   ">
           <div class="row"> 
           <div class="col-12 border  koyu">GELEN</div>
           <div class="col-6 border  koyu">İTHALAT</div>
           <div class="col-6 border  ">`+ithalatToplam+`</div>
           <div class="col-6 border  koyu">İHRACAT</div>
           <div class="col-6 border  ">`+ihracatToplam+`</div>
           <div class="col-6 border  koyu">TOPLAM</div>
           <div class="col-6 border  ">`+(ihracatToplam+ithalatToplam)+`</div>
</div>
           </div>
           </div>
           <div class="col-6">
           <div class="row"> <div class="col-2   "></div>
           <div class="col-2   "></div>
           <div class="col-2   "></div>
           <div class="col-2   "></div>
           <div class="col-2   "></div>
           <div class="col-2   "></div></div>
           </div>
</div>
    </div>
</div>
</div>
</body>

</html>
  
    `);
                popupWin.document.close();
            }).catch(res => {
        });

        /*window.history.back();*/
        /*window.disableModal();*/
        /*axios({
            method: 'post',
            url: Properties.baseUrl + '/tasima/changeDurum',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                id: this.state.makbuzId,
                durum: this.state.makbuzDurum,
            }
        })
            .then(res => {
                window.successful((this.state.showDuzenle ? "Makbuz Güncellendi." : "Makbuz Kaydedildi"));
            }).catch(res => {
            window.unsuccessful((this.state.showDuzenle ? "Makbuz Güncellenemedi." : "Makbuz Kaydedilemedi."));
        });*/
    }

    onClick = (e) => {
        window.inputmaskReady();
    }

    render(props) {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header />
                <SideMenu zrapor="active" />
                <PageContext>
                    <form>
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className="card-title"
                                    style={this.state.showDuzenle ? {display: 'none'} : {display: 'block'}}>Filtre</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-2">
                                        <label  htmlFor="exampleInputEmail1">Tarih</label>

                                            <DateTimePicker style={this.state.showDuzenle ? {display: 'none'} : {
                                                margin: "10px",
                                                display: 'block'
                                            }} onChange={this.onChange} name="tarih" format="dd/MM/yyyy" value={this.state.tarihOr} />

                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1"></label>

                                        <button onClick={this.makbuzYazdir}

                                                type="button" className="btn btn-primary">ÇIKTI AL
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </PageContext>
                <Footer/>
            </div>);
    }
}


export default Zrapor;
